// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../../assets/stylesheets/variables.css\"","customWhite":"#ffffff","borderGrey":"#d5dfdf","container":"_26pmTp4FKMUOllEwQF9ZM9","popup":"_3cSSjP-8EXj82dVURd5I70","text":"_3rj0KQsZ6wf0wU1Q7foQGM"};


//////////////////
// WEBPACK FOOTER
// ./src/common/popup/Popup.css
// module id = 1016
// module chunks = 1